'use client';
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ReferenceLine } from 'recharts';
import { VESSEL_BENCHMARK_DATA } from './analyticsData';

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const d = payload[0]?.payload;
  return (
    <div className="bg-white rounded-xl border shadow-elevated p-3 text-xs" style={{ borderColor: 'hsl(var(--border))' }}>
      <p className="font-semibold mb-1">{d.vessel}</p>
      <p className="text-muted">LSD Score: <span className="font-bold text-foreground tabular-nums">{d.lsd}</span></p>
      <p className="text-muted">Owner: <span className="font-semibold text-foreground">{d.owner}</span></p>
      <p className="text-muted">Scope: <span className="font-semibold text-foreground">{d.scope}</span></p>
    </div>
  );
};

export default function VesselBenchmarkChart() {
  const fleetAvg = Math.round(VESSEL_BENCHMARK_DATA.reduce((s, d) => s + d.lsd, 0) / VESSEL_BENCHMARK_DATA.length);
  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <div className="w-2 h-2 rounded-full" style={{ background: 'hsl(215 15% 50%)' }} />
        <span className="text-xs text-muted">Fleet avg: <strong className="tabular-nums">{fleetAvg}</strong></span>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={VESSEL_BENCHMARK_DATA} layout="vertical" margin={{ top: 0, right: 4, left: -4, bottom: 0 }}>
          <CartesianGrid stroke="hsl(214, 20%, 88%)" strokeDasharray="3 3" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 10, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} domain={[0, 80]} />
          <YAxis dataKey="vessel" type="category" tick={{ fontSize: 9, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} width={90}
            tickFormatter={(v: string) => v.length > 14 ? v.slice(0, 14) + '…' : v} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(218 70% 22% / 0.04)' }} />
          <ReferenceLine x={fleetAvg} stroke="hsl(215, 15%, 55%)" strokeDasharray="4 3" label={{ value: 'Avg', position: 'top', fontSize: 10, fill: 'hsl(215, 15%, 50%)' }} />
          <Bar dataKey="lsd" radius={[0, 4, 4, 0]} maxBarSize={16}>
            {VESSEL_BENCHMARK_DATA.map((entry, i) => (
              <Cell
                key={`bench-cell-${i}`}
                fill={entry.lsd > 60 ? 'hsl(355, 75%, 52%)' : entry.lsd > 45 ? 'hsl(38, 80%, 48%)' : 'hsl(218, 60%, 42%)'}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}